import { tienePermiso } from '../../../utils/permisosUtil';

export const permisosAccesoMixin = {
  computed: {
    permisosAcceso() {
      return {
        accesoModulo: tienePermiso('acceso'),
      };
    },
  },
};
